import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles'

import Avatar from '@material-ui/core/Avatar'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'

import SideMenu from 'components/layout/SideMenu'
import AppBarMenu from 'components/layout/AppBarMenu'

import userSelectors from 'store/selectors/user'
import routerActions from 'store/modules/router'

import {
  USER_MENU,
  GUEST_MENU,
} from 'settings'

const useStyles = makeStyles(theme => {
  return {
    root: {
      height: '100%'
    },
    appbar: {
      flexGrow: 1,
      flex: 1,
    },
    toolbar: {
      paddingLeft: '0px',
      paddingRight: '0px',
      backgroundColor: '#ffffff',
    },
    flex: {
      flex: 1,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      cursor: 'pointer',
    },
    content: {
      height: 'calc(100% - 64px)'
    },
    title: {
      color: '#81591F',
    },
    logo: {
      width: '200px',
      marginRight: theme.spacing(2),
    },
    userName: {
      color: theme.palette.grey[500],
      marginRight: theme.spacing(1),
    },
  }
})

const Layout = ({
  children,
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const user = useSelector(userSelectors.data)

  return (
    <div className={ classes.root }>
      <div className={ classes.appbar }>
        <AppBar position="static">
          <Toolbar className={ classes.toolbar }>
            <SideMenu 
              items={ user ? USER_MENU : GUEST_MENU }
            />
            <div className={ classes.flex } onClick={ () => {
              dispatch(routerActions.navigateTo('home'))
            }}>
              <img className={ classes.logo } src="/img/logo.png" />
              <Typography 
                variant="h6" 
                color="inherit" 
                className={ classes.title }
              >
                Strategy Board
              </Typography>
            </div>
            {
              user && (
                <>
                  <Typography variant="caption" className={ classes.userName }>
                    { user.displayName }
                  </Typography>
                  <Avatar src={ user.photoURL } />
                </>
              )
            }
            
            <AppBarMenu
              items={ user ? USER_MENU : GUEST_MENU }
            />
          </Toolbar>
        </AppBar>
      </div>
      <div className={ classes.content }>
        { children }
      </div>
    </div>
  )
}

export default Layout